export const LOADING_RECT = {
  height: 40,
  width: 40,
}

export const SCALE_PARENT = 0.8
